import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ModalVideo from 'react-modal-video';
import Breadcrumb from '../../components/Breadcrumb';
import Button from '../../components/Button';
import Sidebar from '../../components/Blog/Sidebar';

import blogMainImg from '../../assets/img/blog/details-1-1.jpg';
import blogImg from '../../assets/img/blog/details-1-3.jpg';
import avatarImg1 from '../../assets/img/blog/user1-1.png';
import avatarImg2 from '../../assets/img/blog/user1-2.png';

const BlogDetailsMain = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(!isOpen);
  };

  return (
    <main>
      <Breadcrumb title="Blog Details" subTitle="Blog" />

      <div className="postbox-area pt-120 pb-120">
        <ModalVideo
          channel="youtube"
          isOpen={isOpen}
          videoId="PO_fBTkoznc"
          onClose={() => openModal()}
        />
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-lg-8">
              <div className="postbox-details-wrapper">
                <article className="postbox-item">
                  <div className="postbox-thumb radius mb-35">
                    <img src={blogMainImg} alt="" />
                  </div>
                  <div className="postbox-meta mb-20">
                    <span>
                      <i className="flaticon-user-1"></i>Alrejaof
                    </span>
                    <span>
                      <i className="flaticon-clock"></i>Dec 28, 2022
                    </span>
                    <span>
                      <i className="flaticon-chat"></i>(04) Coments
                    </span>
                    <span>
                      <i className="flaticon-view"></i>1,526 views
                    </span>
                  </div>
                  <div className="postbox-content-box">
                    <h3 className="postbox-title mb-15">
                      Preserving Care Strategy Amidst Food Changes
                    </h3>
                    <div className="postbox-dsc mb-45">
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris..
                      </p>

                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ea
                        commodo consequat. Duis aute irure dolor in
                        reprehenderit in voluptate velit esse cillum dolore eu
                        fugiat nulla pariatur. Excepteur sint occaecat cupidatat
                        non proident, sunt in culpa qui officia deserunt mollit
                        anim id est laborum.
                      </p>

                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ea
                        commodo consequat. Duis aute irure dolor in
                        reprehenderit in voluptate velit esse cillum dolore eu
                        fugiat nulla pariatur.
                      </p>
                    </div>
                    <div className="postbox-blookquote p-relative theme-bg mb-50">
                      <span>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco
                      </span>
                      <span className="quote">
                        <svg
                          width="45"
                          height="33"
                          viewBox="0 0 45 33"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.3454 0C17.4884 0 21.9227 5.07141 21.9226 12.5805C21.8832 23.4907 13.6814 31.2046 1.8492 32.6859C0.751449 32.8234 0.328171 31.3027 1.33906 30.8532C5.87919 28.8344 8.17219 26.2726 8.46836 23.737C8.68964 21.8426 7.65981 20.1831 6.36669 19.8724C3.0143 19.0668 0.768173 14.892 0.768173 10.5773C0.768173 4.73561 5.50378 0 11.3454 0Z"
                            fill="white"
                          />
                          <path
                            d="M34.4236 0C40.5665 0 45.0008 5.07141 45.0007 12.5805C44.9614 23.4907 36.7596 31.2046 24.9273 32.6859C23.8296 32.8234 23.4063 31.3027 24.4172 30.8532C28.9573 28.8344 31.2503 26.2726 31.5465 23.737C31.7678 21.8426 30.7379 20.1831 29.4448 19.8724C26.0924 19.0668 23.8463 14.892 23.8463 10.5773C23.8463 4.73561 28.5819 0 34.4236 0Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-xl-6 col-lg-12 col-md-5">
                        <div className="it-sv-details__banner p-relative">
                          <img src={blogImg} alt="" />
                          <Link
                            className="it-choose-play pulse popup-video"
                            to="#"
                            onClick={openModal}
                          >
                            <i className="fa-sharp fa-solid fa-play"></i>
                          </Link>
                        </div>
                      </div>
                      <div className="col-xl-6 col-lg-12 col-md-7">
                        <div className="it-sv-details__banner-right">
                          <div className="it-sv-details__banner-text mb-30">
                            <h4 className="it-sv-details__banner-title">
                              The medical experts transplant the heart
                            </h4>
                            <p>
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit, sed do eiusmod tempor incididunt.
                            </p>
                          </div>
                          <div className="it-sv-details__banner-list">
                            <ul>
                              <li>
                                <i className="fa-regular fa-circle-check"></i>
                                Lorem ipsum dolor sit amet, consectetur
                              </li>
                              <li>
                                <i className="fa-regular fa-circle-check"></i>
                                Donec pretium vulputate sapien.
                              </li>
                              <li>
                                <i className="fa-regular fa-circle-check"></i>
                                Bibendum neque egestas congue quisque
                              </li>
                              <li>
                                <i className="fa-regular fa-circle-check"></i>
                                Duis at tellus at urna condimentum
                              </li>
                              <li>
                                <i className="fa-regular fa-circle-check"></i>
                                Egestas erat imperdiet sed euismod nisi porta.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="it-sv-details__banner-text mt-40 mb-40">
                      <h4 className="it-sv-details__banner-title">
                        Emergencies Plan
                      </h4>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ea
                        commodo consequat. Duis aute irure dolor in
                        reprehenderit in voluptate velit esse cillum dolore eu
                        fugiat nulla pariatur. Excepteur sint occaecat cupidatat
                        non proident, sunt in culpa qui officia deserunt mollit
                        anim id est laborum.
                      </p>
                    </div>
                  </div>
                  <div className="postbox-tag-box mb-45">
                    <div className="row align-items-center">
                      <div className="col-xl-8">
                        <div className="postbox-tag d-flex align-items-center">
                          <h3 className="postbox-tag-title">Tag</h3>
                          <div className="postbox-tag-content">
                            <a className="active" href="#">
                              Hospital
                            </a>
                            <a href="#">Advice</a>
                            <a href="#">Hospital</a>
                            <a href="#">pharmacy</a>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="postbox-share d-flex align-items-center justify-content-xl-end">
                          <h3 className="postbox-tag-title">Share</h3>
                          <div className="postbox-share-content">
                            <a className="linkedin" href="#">
                              <i className="fa-brands fa-linkedin"></i>
                            </a>
                            <a className="pinterest" href="#">
                              <i className="fa-brands fa-pinterest"></i>
                            </a>
                            <a className="facebook" href="#">
                              <i className="fa-brands fa-facebook"></i>
                            </a>
                            <a className="twitter" href="#">
                              <i className="fa-brands fa-twitter"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="postbox-comment mb-45">
                    <h3 className="postbox-comment-title mb-30">04 Comments</h3>
                    <div className="postbox-comment-item">
                      <div className="postbox-comment-content mb-25 d-sm-flex align-items-start justify-content-between">
                        <ul>
                          <li>
                            <div className="postbox-comment-user p-relative d-flex align-items-start">
                              <div className="postbox-user-thumb">
                                <img src={avatarImg1} alt="" />
                              </div>
                              <div className="postbox-user-info">
                                <h4 className="user-title">Jenny Wilson</h4>
                                <span>MARCH 10, 2024</span>
                                <p>
                                  Lorem ipsum dolor sit amet, consectetur
                                  adipiscing elit, sed do eiusmod tempor <br />{' '}
                                  incididunt ut labore et dolore magna aliqua.
                                </p>
                              </div>
                              <a href="#" className="reply-icon">
                                <svg
                                  width="20"
                                  height="14"
                                  viewBox="0 0 20 14"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M19.0005 13.7501C19.1255 13.7501 19.2505 13.7191 19.3645 13.6561C19.6695 13.4871 19.8175 13.1291 19.7205 12.7941C19.3085 11.3531 18.4165 9.25605 16.5155 7.45605C13.4515 4.55405 9.67747 4.19405 7.74947 4.23805V1.00105C7.74947 0.698053 7.56647 0.424053 7.28648 0.308053C7.00648 0.192053 6.68347 0.256053 6.46947 0.471053L0.469475 6.47105C0.176476 6.76405 0.176476 7.23905 0.469475 7.53205L6.46947 13.5321C6.68447 13.7471 7.00648 13.8121 7.28648 13.6951C7.56647 13.5791 7.74947 13.3051 7.74947 13.0021V9.70105C9.12547 9.46905 10.5045 9.47905 11.8585 9.73905C15.1995 10.3791 17.4185 12.3731 18.4435 13.5061C18.5895 13.6681 18.7935 13.7531 18.9995 13.7531L19.0005 13.7501ZM9.71047 8.03205C8.75447 8.03205 7.79448 8.13805 6.83848 8.34905C6.49448 8.42505 6.25047 8.72905 6.25047 9.08105V11.1881L2.06148 6.99905L6.25047 2.81005V5.02605C6.25047 5.23605 6.33948 5.43805 6.49448 5.58005C6.64948 5.72305 6.85948 5.79305 7.06748 5.77305C8.24248 5.66705 12.3285 5.55605 15.4845 8.54405C16.0525 9.08205 16.5165 9.65105 16.8975 10.2171C15.6485 9.39105 14.0595 8.63005 12.1405 8.26205C11.3365 8.10805 10.5255 8.03105 9.70947 8.03105L9.71047 8.03205Z"
                                    fill="#076CEC"
                                  />
                                </svg>
                              </a>
                            </div>
                          </li>
                          <li className="children">
                            <div className="postbox-comment-user p-relative d-flex align-items-start">
                              <div className="postbox-user-thumb">
                                <img src={avatarImg2} alt="" />
                              </div>
                              <div className="postbox-user-info">
                                <h4 className="user-title">Kristin Watson</h4>
                                <span>MARCH 10, 2024</span>
                                <p>
                                  Lorem ipsum dolor sit amet, consectetur
                                  adipiscing elit, sed do eiusmod tempor <br />{' '}
                                  incididunt ut labore et dolore magna aliqua.
                                </p>
                              </div>
                              <a href="#" className="reply-icon">
                                <svg
                                  width="20"
                                  height="14"
                                  viewBox="0 0 20 14"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M19.0005 13.7501C19.1255 13.7501 19.2505 13.7191 19.3645 13.6561C19.6695 13.4871 19.8175 13.1291 19.7205 12.7941C19.3085 11.3531 18.4165 9.25605 16.5155 7.45605C13.4515 4.55405 9.67747 4.19405 7.74947 4.23805V1.00105C7.74947 0.698053 7.56647 0.424053 7.28648 0.308053C7.00648 0.192053 6.68347 0.256053 6.46947 0.471053L0.469475 6.47105C0.176476 6.76405 0.176476 7.23905 0.469475 7.53205L6.46947 13.5321C6.68447 13.7471 7.00648 13.8121 7.28648 13.6951C7.56647 13.5791 7.74947 13.3051 7.74947 13.0021V9.70105C9.12547 9.46905 10.5045 9.47905 11.8585 9.73905C15.1995 10.3791 17.4185 12.3731 18.4435 13.5061C18.5895 13.6681 18.7935 13.7531 18.9995 13.7531L19.0005 13.7501ZM9.71047 8.03205C8.75447 8.03205 7.79448 8.13805 6.83848 8.34905C6.49448 8.42505 6.25047 8.72905 6.25047 9.08105V11.1881L2.06148 6.99905L6.25047 2.81005V5.02605C6.25047 5.23605 6.33948 5.43805 6.49448 5.58005C6.64948 5.72305 6.85948 5.79305 7.06748 5.77305C8.24248 5.66705 12.3285 5.55605 15.4845 8.54405C16.0525 9.08205 16.5165 9.65105 16.8975 10.2171C15.6485 9.39105 14.0595 8.63005 12.1405 8.26205C11.3365 8.10805 10.5255 8.03105 9.70947 8.03105L9.71047 8.03205Z"
                                    fill="#076CEC"
                                  />
                                </svg>
                              </a>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="postbox-review-form">
                    <h4 className="postbox-review-title mb-15">
                      Leave A Comment
                    </h4>
                    <p className="pb-15">
                      Your email address will not be published. Required fields
                      are marked *
                    </p>
                    <form action="#">
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="postbox-review-input">
                            <input type="text" placeholder="first name:" />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="postbox-review-input">
                            <input type="text" placeholder="your subject:" />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="postbox-review-input">
                            <input type="email" placeholder="Email address:" />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="postbox-review-input">
                            <input type="text" placeholder="Phone:" />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="postbox-review-textarea">
                            <textarea placeholder="write here..."></textarea>
                          </div>
                        </div>
                      </div>
                      <div className="postbox-review-button mt-30">
                        <button className="it-btn-theme" type="submit">
                          <Button btnText="Post Comment" />
                        </button>
                      </div>
                    </form>
                  </div>
                </article>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4">
              <Sidebar />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default BlogDetailsMain;
